import { EmailViewModel } from '../../models/Entities/Person/Email/EmailModels';
import { CommonState } from '../common/state/commonState';

export interface PersonEmailState extends CommonState<EmailViewModel> {
    lastCreated?: EmailViewModel;
}

export const PersonEmailUnloadState: PersonEmailState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
